module.exports = __webpack_public_path__ + "img/img31.5448ff01.png";